import { withRum } from './registry';

// Identifiers on RUM events, so one patient's events can be found in Kibana:
//   user.id · labels.book_id · labels.terminal_id and session.id (both set in init.ts).
// No SDK import here: safe to use from any page; calls wait until the agent starts.

/** Logged-in patient (user.id in APM). Pass nothing on logout. */
export function setRumUser(userId?: string | number | null) {
  withRum(apm => apm.setUserContext(userId ? { id: String(userId) } : {}));
}

/**
 * Device id (labels.terminal_id) once setTerminal() has issued it. init.ts reads the cookie at start,
 * which is too early on a first visit: the cookie only exists after /api/setTerminal answers.
 */
export function setRumTerminal(terminalId?: string | number | null) {
  if (!terminalId) return;
  withRum(apm => apm.addLabels({ terminal_id: String(terminalId) }));
}

/** The book this tab is paying for: later events of the tab carry labels.book_id (always a string). */
export function setRumBook(bookId?: string | number | null) {
  if (!bookId) return;
  withRum(apm => apm.addLabels({ book_id: String(bookId) }));
}
